/**
 * SIM slot labels. A slot is free text: a plain number for the device's own
 * SIM trays ("3") or a description when the SIM sits elsewhere, e.g. in a USB
 * modem ("USB 2") or an attached Teltonika router ("Teltonika").
 */
export const MAX_SLOT_LENGTH = 40;
/** Trims and collapses whitespace; empty input means "no slot". */
export function normalizeSlot(input) {
    const slot = (input ?? "").replace(/\s+/g, " ").trim();
    return slot ? slot : null;
}
/** Comparison key: slots are unique per device, ignoring case. */
export function slotKey(slot) {
    return slot.toLowerCase();
}
/**
 * Slots for `count` SIMs starting at `first`. A trailing number is counted up
 * ("1" → 1, 2, 3; "USB 1" → USB 1, USB 2). Returns null when several SIMs
 * would get the same slot because `first` has no number to count up.
 */
export function consecutiveSlots(first, count) {
    if (first === null)
        return Array.from({ length: count }, () => null);
    if (count <= 1)
        return [first];
    const match = /^(.*?)(\d+)$/.exec(first);
    if (!match)
        return null;
    const [, prefix, digits] = match;
    const start = Number(digits);
    return Array.from({ length: count }, (_, index) => {
        const n = String(start + index).padStart(digits.length, "0");
        return `${prefix}${n}`;
    });
}
/** Display/Simetric label: `"Slot 3"` for numbers, other slots as entered. */
export function formatSlotLabel(slot) {
    if (!slot)
        return "";
    return /^\d+$/.test(slot) ? `Slot ${slot}` : slot;
}
/** Natural order (2 before 10), slot-less SIMs last. */
export function compareSlots(a, b) {
    if (!a || !b)
        return (a ? 0 : 1) - (b ? 0 : 1);
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
}
